import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import { TableTitle } from "../styles/CommonQuestionsStyles";
import { buildRequirementRows } from "./productTableUtils";
import { ProductRequirementData } from "./productTableTypes";

type ProductRequirementTableProps = {
  requirement: ProductRequirementData;
};

export const ProductRequirementTable = ({
  requirement,
}: ProductRequirementTableProps) => {
  const rows = buildRequirementRows(requirement);

  return (
    <TableContainer
      component={Paper}
      sx={{
        margin: "15px 0",
        overflowX: "auto",
      }}
    >
      <Table
        sx={{ minWidth: 300 }}
        size="small"
        aria-label={`Carências do plano ${requirement.plan}`}
      >
        <TableHead>
          <TableRow sx={{ background: "#fd6520" }}>
            <TableCell colSpan={3}>
              <TableTitle>{requirement.plan}</TableTitle>
            </TableCell>
          </TableRow>

          <TableRow sx={{ background: "#f7f7f5" }}>
            <TableCell width={150} component="th" scope="col">
              <strong>Grupo de Carência</strong>
            </TableCell>

            <TableCell component="th" scope="col">
              <strong>Prazos</strong>
            </TableCell>

            <TableCell component="th" scope="col">
              <strong>Procedimentos</strong>
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {rows.map((row) => (
            <TableRow
              key={`${requirement.plan}_${row.group}`}
              sx={{
                "&:last-child td, &:last-child th": {
                  border: 0,
                },
              }}
            >
              <TableCell component="th" scope="row">
                {row.group}
              </TableCell>

              <TableCell>{row.time}</TableCell>

              <TableCell>{row.procedures}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};